import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export interface OrbitNetworkNode {
  id: string;
  name: string;
  initial: string;
  x: number;
  y: number;
  photoURL?: string;
  pending?: boolean;
}

@Component({
  selector: 'om-orbit-network',
  templateUrl: './orbit-network.html',
  styleUrl: './orbit-network.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrbitNetwork {
  protagonists = input.required<OrbitNetworkNode[]>();
  members = input.required<OrbitNetworkNode[]>();
  mobileScale = input<number>(0.72);

  /** Outer ring diameter adapts to member count to prevent overlap. */
  readonly outerRingSize = computed(() => {
    const count = this.members().length;
    if (count <= 4) return 304;
    if (count <= 6) return 340;
    return 380;
  });

  readonly innerRingSize = computed(() => {
    const count = this.protagonists().length;
    return count <= 1 ? 120 : 160;
  });
}
